import React, { useEffect, useRef } from 'react';
import { Button } from '@material-ui/core';
//@ts-ignore
import SearchIcon from 'public/images/icons/search-thin.svg';
//@ts-ignore
import CloseIcon from 'public/images/icons/close.svg';
import { useSearchStore } from '@services/stores/SearchStore';
import { makeStyles } from '@material-ui/styles';
import useApplicationStore from '@services/stores/ApplicationStore';
import { useTranslation } from 'tools/i18n';
import { TrackingContext } from 'components/providers/tracking';
import { useContext } from 'react';
import theme from '@components/theme';

const useStyles = makeStyles({
    search__inner: {
        position: 'relative',
        zIndex: 100,
        width: '100%',
        padding: '0',
    },
    search__input: {
        width: '100%',
        height: 38,
        padding: '1.25em 1em',
        margin: 0,
        fontSize: 16,
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.header.search.color,
        borderRadius: '4px',
        border: `1px solid ${theme.palette.primary.backgroundContrast}`,
        appearance: 'none',
        '&:focus-visible': {
            outline: 'none'
        },
        '&.glued.focus': {
            boxShadow: 'none'
        },
        '&.focus': {
            outline: 'none'
        },
        '&::placeholder': {
            color: theme.palette.header.search.color
        },
        '.xmas &': {
            color: '#fff',
            backgroundColor: '#566259',
            border: 'none',
            borderRadius: 2,
            '&::placeholder': {
                color: '#fff',
            },
        },
        '.blackfriday &': {
            color: '#fff',
            backgroundColor: '#666',
            border: 'none',
            borderRadius: 2,
            '&::placeholder': {
                color: '#fff',
            },
        },
    },
    icon__button: {
        position: 'absolute',
        minWidth: 'auto',
        minHeight: 'auto',
        top: 0,
        bottom: 0,
        right: 0,
        padding: '0 15px',
        backgroundColor: 'transparent',
        '.xmas &': {
            color: '#fff',
            strokeWidth: 1
        },
        '.blackfriday &': {
            color: '#fff',
            strokeWidth: 1
        },

    },
    icon__button_control: {
        borderTopLeftRadius: '0',
        borderBottomLeftRadius: '0',
        '&.glued': {
            borderRadius: 0
        },
    },
    control__icon: {
        width: 18,
        height: 18,
        '.blackfriday &, .xmas &': {
            color: '#fff',
            strokeWidth: 0.7
        },
        '&.focus *': {
            stroke: theme.palette.primary.light,
            '.xmas &': {
                stroke: '#fff',
                strokeWidth: 1
            },
            '.blackfriday &': {
                stroke: '#fff',
                strokeWidth: 1
            }
        },
    },
}, { name: 'searchInput'});

export default function SearchInput() {
    const classes = useStyles();
    const { t } = useTranslation();
    const { actions } = useContext(TrackingContext);

    const {
        query,
        setQuery,
        clearSearch,
        goToSearchResults,
        onFocus,
        onKeyDown,
        setSearchInputRef
    } = useSearchStore();

    const toggleDrawer = useApplicationStore((state) => state.methods.toggleDrawer);
    const focus = useApplicationStore((state) => state.modals.searchOpen);
    const searchInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setSearchInputRef(searchInputRef);
    }, [setSearchInputRef]);

    useEffect(() => {
        onFocus(actions, t);
    }, [focus, onFocus, actions, t]);

    return (
        <div className={classes.search__inner}>
            <input
                ref={searchInputRef}
                type="text"
                placeholder={t('search')}
                name="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={onKeyDown}
                autoComplete="one-time-code"
                autoCorrect="off"
                className={[classes.search__input, focus ? 'focus' : ''].join(' ')}
                onFocus={() => toggleDrawer('searchOpen', true)}
            />
            <Button
                onClick={!focus ? goToSearchResults : clearSearch}
                className={[
                    classes.icon__button,
                    classes.icon__button_control,
                    focus ? 'focus' : ''
                ].join(' ')}
            >
                {!focus ? (
                    <SearchIcon
                        className={[classes.control__icon, focus ? 'focus' : ''].join(' ')}
                    />
                ) : (
                    <CloseIcon
                        className={[classes.control__icon, focus ? 'focus' : ''].join(' ')}
                    />
                )}
            </Button>
        </div>
    );
};
